import React, { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { FinalizarApelacion } from "../../components/Apelaciones/FinalizarApelacion";
import {
  PlaceholderInput,
  PlaceholderTabla,
} from "../../components/Otros/Placeholder";
import { InformacionProcesoCorto } from "../../components/ProcesosDeCalificacion/InformacionProcesoCorto";
import { 
  cargarApelaciones, 
  cargarContestadas, 
  cargarDatosProceso, 
  cargarNoContestadas, 
  cargarProcesoActivo} from "../../utils/Datos";
import { UrlWs } from "../../utils/Global";


export const ProcesoConformidad = () => {
  const [searchParams] = useSearchParams();

  const [listaApelaciones, setListaApelaciones] = useState(null);
  const [listaNoContestadas, setListaNoContestadas] = useState(null);
  const [listaContestadas, setListaContestadas] = useState(null);
  const [id_participant, setId_participant] = useState(null);
  const [id_qualifications, setId_qualifications] = useState(null);
  const [proceso, setproceso] = useState(null);

  const [idProcess, setidProcess] = useState(null)
    useEffect(() => {  
      cargarProcesoActivo().then((datos) => {
        setidProcess(datos.id_process);
        setproceso(datos);

        cargarApelaciones(datos.id_process).then((respuesta) => {
          if (respuesta.status) {
            console.log('hay apelaciones',respuesta);
            setListaApelaciones(respuesta.datos);
          } else {
            setListaApelaciones([]);
          }
        });

        cargarNoContestadas(datos.id_process).then((respuesta) => {
          if (respuesta.status === true) {
            setListaNoContestadas(respuesta.datos);
          } else {
            setListaNoContestadas([]);
          }
        });
        cargarContestadas(datos.id_process).then((respuesta) => {
          if (respuesta.status === true) {
            setListaContestadas(respuesta.datos);
          } else {
            setListaContestadas([]);
          }
        });
  
      });
    }, []);

 

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                PROCESO DE CONFORMIDAD DE CALIFICACIONES{" "}
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4" />
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>
                <li className="breadcrumb-item text-dark"> -</li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DELPROCESO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    {proceso !== null ? (
                      <InformacionProcesoCorto
                        proceso={proceso}
                      ></InformacionProcesoCorto>
                    ) : (
                      <></>
                    )}

                    <div className="row mb-8">
                      <div className="rounded border p-10 pb-10 d-flex flex-wrap">
                        <span className="menu-link me-5">
                          <span className="menu-icon">
                            <span className="svg-icon svg-icon-6 svg-icon-info me-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                          </span>
                          <span className="menu-title fw-bold">
                            Total Proceso:
                          </span>
                          <span className="badge badge-light-info">
                            {listaApelaciones === null ||
                            listaNoContestadas === null ||
                            listaContestadas === null
                              ? "-"
                              : listaApelaciones?.length +
                                listaContestadas?.length +
                                listaNoContestadas?.length}
                          </span>
                        </span>
                        <span className="menu-link me-5">
                          <span className="menu-icon">
                            <span className="svg-icon svg-icon-6 svg-icon-success me-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                          </span>
                          <span className="menu-title fw-bold ">
                            Contestadas:
                          </span>
                          <span className="badge badge-light-success">
                            {listaContestadas === null
                              ? "-"
                              : listaContestadas?.length}
                          </span>
                        </span>
                        <span className="menu-link me-5">
                          <span className="menu-link me-5">
                            <span className="menu-icon">
                              <span className="svg-icon svg-icon-6 svg-icon-danger me-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                            </span>
                          </span>
                          <span className="menu-title fw-bold">
                            Por contestar:
                          </span>
                          <span className="badge badge-light-danger">
                            {listaNoContestadas === null
                              ? "-"
                              : listaNoContestadas?.length}
                          </span>
                        </span>
                        <span className="menu-link me-5">
                          <span className="menu-link me-5">
                            <span className="menu-icon">
                              <span className="svg-icon svg-icon-6 svg-icon-danger me-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                            </span>
                          </span>
                          <span className="menu-title fw-bold">Apelación:</span>
                          <span className="badge badge-light-danger">
                            {listaApelaciones === null
                              ? "-"
                              : listaApelaciones?.length}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 ">
                <div className="card ">
                  <div className="card-header ">
                    <h3 className="card-title align-items-start flex-column ">
                      <span className="card-label fw-bolder text-dark ">
                        GESTIÓN DE NOTIFICACIONES Y APELACIONES EN PROCESO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body ">
                    <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 ">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#apelacion"
                        >
                           Apelación <span class="badge badge-primary">{listaApelaciones?.length ?? 0}</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link "
                          data-bs-toggle="tab"
                          href="#no-contestadas"
                        >
                           No contestadas <span class="badge badge-primary">{listaNoContestadas?.length ?? 0}</span>
                          
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link "
                          data-bs-toggle="tab"
                          href="#contestadas"
                        >
                           Contestadas <span class="badge badge-primary">{listaContestadas?.length ?? 0}</span>
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content" id="tabruth">
                      <div
                        className="tab-pane fade show active"
                        id="apelacion"
                        role="tabpanel"
                      >
                        {listaApelaciones != null ? (
                          <TablaApelacion
                            listaApelaciones={listaApelaciones}
                            setId_qualifications={setId_qualifications}
                            setId_participant={setId_participant}
                          ></TablaApelacion>
                        ) : (
                          <>
                            <PlaceholderTabla></PlaceholderTabla>
                          </>
                        )}
                      </div>
                      <div
                        className="tab-pane fade"
                        id="no-contestadas"
                        role="tabpanel"
                      >
                        {listaNoContestadas != null ? (
                          <TablaNoContestadas
                            listaNoContestadas={listaNoContestadas}
                            idProcess={idProcess}
                          ></TablaNoContestadas>
                        ) : (
                          <>
                            <PlaceholderTabla></PlaceholderTabla>
                          </>
                        )}
                      </div>
                      <div
                        className="tab-pane fade"
                        id="contestadas"
                        role="tabpanel"
                      >
                        {listaContestadas != null ? (
                          <TablaContestadas
                            listaContestadas={listaContestadas}
                            idProcess={idProcess}
                          ></TablaContestadas>
                        ) : (
                          <>
                            <PlaceholderTabla></PlaceholderTabla>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FinalizarApelacion
        id_qualifications={id_qualifications}
        id_participant={id_participant}
        idProcess={idProcess}
      ></FinalizarApelacion>
    </>
  );
};

export const TablaApelacion = ({
  listaApelaciones,
  setId_qualifications,
  setId_participant,
}) => {
  console.log(listaApelaciones);
  return (
    <div className="table-responsive">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th>Rut</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Unidad</th>
            <th>Precalificar</th>
            <th>Verificar</th>
          </tr>
        </thead>
        <tbody>
          {listaApelaciones!=null && listaApelaciones.length > 0 ? (
            listaApelaciones.map((d) => {
              return (
                <tr key={d.id_qualifications}>
                  <td>{d.rutOfficer}</td>
                  <td>{d.nameOficcer}</td>
                  <td>{d.nameDmunicipal}</td>
                  <td>{d.nameUmunicipal}</td>
                  <td>{d.namePrequalifier}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                      data-bs-toggle="modal"
                      data-bs-target="#m-"
                      onClick={() => {
                        setId_qualifications(d.id_qualifications);
                        setId_participant(d.id_participant);
                      }}
                    >
                       Finalizar Apelación
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6}>No hay datos para mostrar</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export const TablaNoContestadas = ({ listaNoContestadas,idProcess }) => {
  return (
    <div className="table-responsive">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th>Rut</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Unidad</th>
            <th>Precalificar</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {listaNoContestadas.length > 0 ? (
            listaNoContestadas.map((d) => {
              return (
                <tr key={d.id_qualifications}>
                  <td>{d.rutOfficer}</td>
                  <td>{d.nameOficcer}</td>
                  <td>{d.nameDmunicipal}</td>
                  <td>{d.nameUmunicipal}</td>
                  <td>{d.namePrequalifier}</td>
                  <td>
                    <NavLink
                      to={`/verProcesoFuncionario/${idProcess}/${d.id_participant}`}
                      className="btn btn-sm btn-primary"
                      target="_blank"
                    >
                       ver
                    </NavLink>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6}>No hay datos para mostrar</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
export const TablaContestadas = ({ listaContestadas,idProcess }) => {
  return (
    <div className="table-responsive">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th>Rut</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Unidad</th>
            <th>Precalificar</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {listaContestadas.length > 0 ? (
            listaContestadas.map((d) => {
              return (
                <tr key={d.id_qualifications}>
                  <td>{d.rutOfficer}</td>
                  <td>{d.nameOficcer}</td>
                  <td>{d.nameDmunicipal}</td>
                  <td>{d.nameUmunicipal}</td>
                  <td>{d.namePrequalifier}</td>
                  <td>
                    <NavLink
                      to={`/verProcesoFuncionario/${idProcess}/${d.id_participant}`}
                      className="btn btn-sm btn-primary"
                      target="_blank"
                    >
                       ver
                    </NavLink>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6}>No hay datos para mostrar</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
